function BrandLockup({ title, subtitle }) {
  return (
    <div className="brandLockup">
      <p className="brandLockup__title">{title}</p>
      {subtitle ? <p className="brandLockup__subtitle">{subtitle}</p> : null}
    </div>
  );
}

export default BrandLockup;
